import { useTranslation } from 'react-i18next';
import {
  QuasiPrimaryButton,
  QuasiSecondaryButton,
  QuasiShell,
  QuasiSpinner,
  QuasiStage,
  QuasiStageActions,
  QuasiStageText,
  QuasiStageTitle,
  QuasiStatusIcon,
} from '../components/QuasiShell';

export const QuasiWaitingPage = () => {
  const { t } = useTranslation();
  return (
    <QuasiShell>
      <QuasiStage>
        <QuasiSpinner />
        <QuasiStageTitle>{t('quasi.preparingTitle')}</QuasiStageTitle>
        <QuasiStageText>{t('quasi.preparingText')}</QuasiStageText>
      </QuasiStage>
    </QuasiShell>
  );
};

export const QuasiStatusPage = ({
  mark,
  title,
  text,
  primary,
  secondary,
}: {
  mark: 'success' | 'error' | 'time';
  title: string;
  text?: string;
  primary?: { label: string; onClick: () => void };
  secondary?: { label: string; onClick: () => void; element?: string };
}) => (
  <QuasiShell>
    <QuasiStage>
      <QuasiStatusIcon tone={mark} />
      <QuasiStageTitle>{title}</QuasiStageTitle>
      {text && <QuasiStageText>{text}</QuasiStageText>}
      <QuasiStageActions>
        {primary && (
          <QuasiPrimaryButton type='button' onClick={primary.onClick}>{primary.label}</QuasiPrimaryButton>
        )}
        {secondary && (
          <QuasiSecondaryButton type='button' data-sentry-element={secondary.element} onClick={secondary.onClick}>
            {secondary.label}
          </QuasiSecondaryButton>
        )}
      </QuasiStageActions>
    </QuasiStage>
  </QuasiShell>
);

/** The offer ran out and nothing else is coming for this ticket. */
export const QuasiSessionExpiredPage = ({ onBack }: { onBack: () => void }) => {
  const { t } = useTranslation();
  return (
    <QuasiStatusPage
      mark='time'
      title={t('quasi.sessionExpiredTitle')}
      text={t('quasi.sessionExpiredText')}
      primary={{ label: t('quasi.back'), onClick: onBack }}
    />
  );
};
